import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  dimension,
  margin,
  position,
  padding,
  overflow,
} from '../styleHelper2';

const StyledPopup = styled.div`
  position: absolute;
  z-index: 99;
  top: 100%;
  left: ${props => (props.anchor === 'right' ? 'auto' : '0px')};
  right: ${props => (props.anchor === 'right' ? '0px' : 'auto')};
  min-width: 100%;
  border-radius: 11px;
  margin-top: ${props => props.theme.margin.small};
  background-color: ${props => props.theme.background.background100};
  box-shadow: ${props => props.theme.shadow.popup};
  border: 1px solid ${props => props.theme.border.border600};
  ${props => (props.anchor === 'center' ? 'left: 50%;' : '')}
  ${props => (props.anchor === 'center' ? 'transform: translateX(-50%);' : '')}
  ${dimension()}
  ${margin()}
  ${position()}
  ${padding()}
  ${overflow()}
`;

const Popup = ({ show, children, width, ...props }) => {
  return show ? (
    <StyledPopup width={width} {...props}>
      {children}
    </StyledPopup>
  ) : null;
};

Popup.propTypes = {
  show: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  anchor: PropTypes.string,
  width: PropTypes.string,
};

Popup.defaultProps = {
  show: false,
  className: null,
  children: null,
  anchor: null,
  width: 'auto',
};

export default Popup;
